// info.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InfoService {
  constructor(private http: HttpClient) {}

  async getIPAddress(): Promise<string> {
    try {
      const res = await firstValueFrom(
        this.http.get<{ ip: string }>('https://api.ipify.org?format=json')
      );
      return res.ip;
    } catch (error) {
      return 'Unavailable';
    }
  }

  getBrowserInfo(): string {
    return navigator.userAgent;
  }
}
